// extracted by mini-css-extract-plugin
export default {"social-link":"socialLink_social-link__3dkW5"};